import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-5" }
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = { class: "text-lg font-bold" }
const _hoisted_4 = { class: "text-xs text-gray-500" }
const _hoisted_5 = { class: "flex mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm mt-3"
}

import { computed, toRefs } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewCard',
  props: {
    author_name: {},
    text: {},
    profile_photo_url: {},
    rating: {},
    time: {},
    locale: {}
  },
  setup(__props: any) {

const props = __props
const { time, rating, locale } = toRefs(props)

const date = computed(() =>
    new Intl.DateTimeFormat(locale.value === 'en' ? 'en-US' : 'sl-SI', {
        month: 'long',
        year: 'numeric',
    }).format(time.value * 1000),
)

return (_ctx: any,_cache: any) => {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { class: "review-card !pt-5 !pb-8 !px-5 !text-blue-gray-700" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "avatar",
          style: _normalizeStyle({ backgroundImage: `url(${__props.profile_photo_url})` })
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.author_name), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(date.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rating), (_) => {
          return (_openBlock(), _createElementBlock("svg", {
            class: "star",
            key: _,
            viewBox: "0 0 24 24"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("path", { d: "M12 2l2.7 7.9h8.3l-6.7 4.9 2.7 7.9-6.7-4.9-6.7 4.9 2.7-7.9-6.7-4.9h8.3L12 2z" }, null, -1)
          ]))]))
        }), 128))
      ]),
      (__props.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.text), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})